import styled from 'styled-components';

import { embeddedCard } from '../layout';

/** Fields on the left, preview on the right; wraps to preview-below-fields on narrow screens. */
export const FormColumns = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 24px;
`;

export const FormFields = styled.div`
  flex: 1 1 480px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const PreviewSection = styled.section`
  flex: 0 1 540px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: sticky;
  top: 0;
  padding: 16px 20px 20px;
  border-radius: 8px;
  background: ${p => p.theme.color.Neutral0};
  ${embeddedCard}

  h2 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: ${p => p.theme.color.Neutral100};
  }
`;

/** The SDK preview draws the card frame itself, with the Important note below it. */
export const ImportantNote = styled.p`
  margin: 0;
  font-size: 12px;
  color: ${p => p.theme.color.Neutral80};
`;

export const PreviewFrame = styled.div`
  min-width: 0;
`;
